import { Alert, AlertProps } from '@mui/material';
import {
  CcfCallResloveIcon,
  CcfCloseIcon,
  CcfIconButton,
} from '@nice-ccf/ui-controls';
import styles from './ccf-alert.module.scss';

/* eslint-disable-next-line */
export interface CcfAlertProps extends AlertProps {
  closeAlert(): void;
}

/**
 * Function is sed as wrapper for material UI alert component
 * @param param0 -CcfAlertProps
 * @returns material ui alert component
 * @example <CcfAlert/>
 */
export function CcfAlert({ closeAlert, children, ...other }: CcfAlertProps) {
  return (
    <Alert
      {...other}
      variant="filled"
      severity="success"
      iconMapping={{
        success: (
          <CcfCallResloveIcon
            className={styles.successTick}
            fontSize="inherit"
          />
        ),
      }}
      action={
        <CcfIconButton
          aria-label="close"
          color="inherit"
          size="small"
          onClick={() => {
            closeAlert();
          }}
        >
          <CcfCloseIcon className={styles.closeIcon} />
        </CcfIconButton>
      }
      classes={{
        filledSuccess: styles.successToast,
      }}
    >
      {children}
    </Alert>
  );
}

export default CcfAlert;
